import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import MainLayout from './MainLayout';

const FileUploadPage = () => {
  const navigate = useNavigate();
  const [yamlFile, setYamlFile] = useState(null);
  const [xmlFile, setXmlFile] = useState(null);
  const [expFile, setExpFile] = useState(null); // ✅ New state
  const [projectName, setProjectName] = useState('');
  const [projectDesc, setProjectDesc] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const name = localStorage.getItem('project_name');
    const desc = localStorage.getItem('project_description');
    if (name) setProjectName(name);
    if (desc) setProjectDesc(desc);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!yamlFile || !xmlFile) {
      setMessage('Please select both YAML and XML files.');
      return;
    }

    const formData = new FormData();
    formData.append('yaml_file', yamlFile);
    formData.append('xml_file', xmlFile);
    if (expFile) {
      formData.append('exp_file', expFile); // ✅ Correct name
    }

    const token = localStorage.getItem('token');
    const project_id = localStorage.getItem('project_id');

    try {
      const response = await axios.post(
        `https://openmkm.vidyayug.com/api/upload/input?project_id=${project_id || ''}&name=${encodeURIComponent(projectName)}&description=${encodeURIComponent(projectDesc)}`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `${token}`,
          },
        }
      );

      const { project_id: returnedProjectId } = response.data;

      if (returnedProjectId) {
        localStorage.setItem('project_id', returnedProjectId);
        setMessage('Files uploaded successfully! Project ID saved.');

        // clear project name/description after use
        localStorage.removeItem('project_name');
        localStorage.removeItem('project_description');

        setTimeout(() => {
          navigate('/run-openmkm');
        }, 1000);
      } else {
        setMessage('Files uploaded, but no project ID received.');
      }
    } catch (err) {
      console.error(err);
      setMessage('Failed to upload files.');
    }
  };

  return (
    <MainLayout>
      <div style={styles.container}>
        <form onSubmit={handleSubmit} style={styles.form}>
          <h2>Upload Input Files</h2>
          <input
            type="text"
            placeholder="Project Name"
            value={projectName}
            onChange={(e) => setProjectName(e.target.value)}
            required
            style={styles.input}
          />
          <input
            type="text"
            placeholder="Project Description"
            value={projectDesc}
            onChange={(e) => setProjectDesc(e.target.value)}
            required
            style={styles.input}
          />
          <label style={styles.label}>YAML File</label>
          <input
            type="file"
            accept=".yaml,.yml"
            onChange={(e) => setYamlFile(e.target.files[0])}
            style={styles.input}
          />
          <label style={styles.label}>XML File</label>
          <input
            type="file"
            accept=".xml"
            onChange={(e) => setXmlFile(e.target.files[0])}
            style={styles.input}
          />
          <label style={styles.label}>Experimental CSV File</label>
          <input
            type="file"
            accept=".csv"
            onChange={(e) => setExpFile(e.target.files[0])}
            style={styles.input}
          />
          <button type="submit" style={styles.button}>Upload</button>
          {message && <p>{message}</p>}
        </form>
      </div>
    </MainLayout>
  );
};

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    minHeight: 'calc(100vh - 40px)',
    paddingTop: '40px',
    background: '#eef2f5',
  },
  form: {
    background: '#fff',
    padding: '30px',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
    width: '400px',
  },
  input: {
    display: 'block',
    width: '100%',
    marginBottom: '15px',
    padding: '10px',
    border: '1px solid #ccc',
    borderRadius: '4px',
  },
  button: {
    width: '100%',
    padding: '10px',
    background: '#28a745',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
  },
  label: {
    marginBottom: '5px',
    fontWeight: 'bold',
    display: 'block',
  },
};

export default FileUploadPage;
